import { convertToTitleCase } from "js/formatting";
import { Disclosure } from "@headlessui/react";

import config from "config/config";
import { getImage } from "js/utilities";
const ChaseHHPCCInfo = () => {
  return (
    <>
      <div className="font-body text-theme-text-primary">
        <div className="flex flex-col min-h-screen">
          <div className="container py-4">
            <div className="flex justify-between flex-row-reverse items-center lg:grid lg:gap-x-2 lg:grid-cols-[1fr_max-content_max-content_max-content_max-content] lg:items-center">
              <div className="lg:flex lg:items-center px-0">
                <img
                  src={getImage("logo_blue.png")}
                  className="ui-logo-header"
                  alt={`${convertToTitleCase(config.COMPANY_NAME)} Logo`}
                />
                <div className="9lg:flex text-[color:var(--theme-color-portal-title)] font-semibold ml-6 px-6 border-l border-theme-rule"></div>
              </div>
            </div>
          </div>
          <header className="lg:bg-white shadow-drop">
            <div id="id_header">
              <div id="id_mainMenu" className="">
                <div className="ui-navbar w-64 lg:flex lg:w-full lg:z-auto lg:relative h-12">
                  <div
                    id="id_mobileMenuMask"
                    className="hidden fixed inset-0 w-full h-full bg-ui-gray-dark opacity-40 z-[800] lg:hidden lg:inset-auto lg:z-auto"
                  ></div>

                  <nav
                    aria-label="Main"
                    className="ui-main-menu hidden absolute w-64 z-[802] bottom-0 bg-white lg:flex lg:relative lg:w-full lg:z-auto lg:inset-auto lg:bg-transparent lg:container"
                  ></nav>
                </div>
              </div>
            </div>
          </header>
          <main id="mainContent" className="flex flex-col flex-grow container">
            <div className="border border-transparent">
              <div className="container pt-6 pb-4 min-h-12">
                <nav aria-label="Breadcrumb" className="ui-breadcrumb text-xs">
                  <ol className="list-none">
                    <li key={`breadcrumb`}>
                      <a disabled>Make a payment</a>
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="container mb-8">
                <h1>Payment information</h1>
                <p>Please provide you payment information below</p>
                <hr />
              </div>
              <div className="ui-form-make-payment container">
                {/* <!-- Step 5 --> */}
                <div className="flex flex-row md:ml-8 md:mr-0 lg:ml-20 xl:ml-28 lg:pr-16">
                  <div className="w-8 md:flex md:flex-col md:justify-center md:mr-14">
                    <div className="flex justify-center items-center mt-6 mb-4">
                      <div className="inline-flex justify-center items-center h-8 w-8 text-white bg-ui-blue-dark rounded-full overflow-hidden">
                        6
                      </div>
                    </div>
                    <div className="flex h-full w-px bg-ui-gray-medium-light mx-auto overflow-hidden"></div>
                  </div>

                  <div className="w-full flex-grow">
                    <div className="ui-card relative px-4 py-4 mb-6 lg:px-6">
                      <Disclosure as="div">
                        {({ open }) => (
                          <>
                            <Disclosure.Button as="div" role="presentation">
                              <div className="flex justify-between items-start">
                                <h2 className="flex flex-grow font-body font-bold text-xl">
                                  Credit card
                                </h2>
                                <div className="font-semibold text-sm whitespace-nowrap">
                                  Step 6
                                </div>
                              </div>
                            </Disclosure.Button>
                            <div
                              id="ID_paymentStep5Options"
                              className="pt-4 mt-2 lg:pt-6 border-t border-theme-rule-light"
                            >
                              <Disclosure.Panel className="pb-2 text-sm" static>
                                <p className="mb-4 text-sm">
                                  Provide billing name and info
                                </p>
                                <div id="errorMsg"></div>
                                <p>[[FORM INSERT]]</p>
                                {/* <div>
                                  <div class="md:flex md:items-center mb-6">
                                    <div class="md:w-1/3">
                                      <label
                                        for="billing_name"
                                        className="block md:text-right mb-1 md:mb-0 pr-4"
                                      >
                                        Name
                                      </label>
                                    </div>
                                    <div class="md:w-2/3">
                                      <input
                                        type="text"
                                        id="billing_name"
                                        name="billing_name"
                                        placeholder=""
                                      />
                                    </div>
                                  </div>
                                  <div class="md:flex md:items-center mb-6">
                                    <div class="md:w-1/3">
                                      <label
                                        for="total_amount"
                                        className="block md:text-right mb-1 md:mb-0 pr-4"
                                      >
                                        Amount
                                      </label>
                                    </div>
                                    <div class="md:w-2/3">
                                      <input
                                        type="text"
                                        id="total_amount"
                                        name="total_amount"
                                        class="hps-input"
                                        placeholder=""
                                      />
                                    </div>
                                  </div>
                                  <div class="md:flex md:items-center mb-6">
                                    <div class="md:w-1/3">
                                      <label
                                        for="pan"
                                        className="block md:text-right mb-1 md:mb-0 pr-4"
                                      >
                                        Card number
                                      </label>
                                    </div>
                                    <div class="md:w-2/3">
                                      <input
                                        type="text"
                                        id="pan"
                                        name="pan"
                                        autocomplete="cc-number"
                                        class="hps-input"
                                        placeholder=""
                                      />
                                    </div>
                                  </div>
                                  <div class="md:flex md:items-center mb-6">
                                    <div class="md:w-1/3">
                                      <label
                                        for="cvv"
                                        class="block md:text-right mb-1 md:mb-0 pr-4"
                                      >
                                        CVV/CVC
                                      </label>
                                    </div>
                                    <div class="md:w-2/3">
                                      <input
                                        type="text"
                                        id="cvv"
                                        name="cvv"
                                        autocomplete="cc-csc"
                                        class="hps-input"
                                        placeholder=""
                                      />
                                    </div>
                                  </div>
                                  <div class="md:flex md:items-center mb-6">
                                    <div class="md:w-1/3">
                                      <label
                                        for="exp_month"
                                        class="block md:text-right mb-1 md:mb-0 pr-4"
                                      >
                                        Exp month
                                      </label>
                                    </div>
                                    <div class="md:w-2/3">
                                      <select
                                        id="exp_month"
                                        name="exp_month"
                                        autocomplete="cc-exp-month"
                                        class="hps-dropdown"
                                      >
                                        <option value="01">January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="md:flex md:items-center mb-6">
                                    <div class="md:w-1/3">
                                      <label
                                        for="exp_year"
                                        class="block md:text-right mb-1 md:mb-0 pr-4"
                                      >
                                        Exp year
                                      </label>
                                    </div>
                                    <div class="md:w-2/3">
                                      <select
                                        id="exp_year"
                                        name="exp_year"
                                        autocomplete="cc-exp-year"
                                        class="hps-dropdown"
                                      >
                                        <option value="2022">2022</option>
                                        <option value="2023">2023</option>
                                        <option value="2024">2024</option>
                                        <option value="2025">2025</option>
                                        <option value="2026">2026</option>
                                        <option value="2027">2027</option>
                                        <option value="2028">2028</option>
                                        <option value="2029">2029</option>
                                        <option value="2030">2030</option>
                                        <option value="2031">2031</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="md:flex md:items-center mb-6">
                                    <div class="md:w-1/3"></div>
                                    <div class="md:w-2/3">
                                      <label className="inline-flex items-center">
                                        <input
                                          type="checkbox"
                                          className="mr-2"
                                          value="ccdefault"
                                          disabled
                                        />
                                        Make this credit card my default payment
                                        method
                                      </label>
                                    </div>
                                  </div>
                                  <div class="md:flex md:items-center mb-6">
                                    <div class="md:w-1/3"></div>
                                    <div class="md:w-2/3">
                                      <label className="inline-flex items-center">
                                        <input
                                          type="checkbox"
                                          className="mr-2"
                                          value="ccautopay"
                                          disabled
                                        />
                                        Enroll in autopay with payment method
                                      </label>
                                    </div>
                                  </div>
                                  <div class="md:flex md:items-center mb-6">
                                    <div class="md:w-1/3"></div>
                                    <div class="md:w-2/3">
                                      <button
                                        id="submitBtn"
                                        type="submit"
                                        className="ui-btn-primary min-w-[140px]"
                                      >
                                        Pay
                                      </button>
                                      <button
                                        id="cancelBtn"
                                        type="button"
                                        className="ui-btn-secondary min-w-[140px]"
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                </div> */}
                              </Disclosure.Panel>
                            </div>
                          </>
                        )}
                      </Disclosure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <footer>
            <div className="container py-6 lg:py-8">
              <div className="flex w-full flex-grow justify-between items-start">
                <div className="flex flex-wrap flex-row items-start text-sm  md:items-center md:text-base"></div>
                <div className="flex">
                  <div className="lg:flex lg:items-center px-0"></div>
                  <div id="everlakeLogoFooter" className="ui-logo">
                    <img
                      src={getImage("logo_blue.png")}
                      className="ui-logo-footer-mobile"
                      alt="Everlake Logo"
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col">
                <hr className="mt-2 mb-4" />
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default ChaseHHPCCInfo;
